//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ExposeApiResponseDataToCalculations: FeatureFlag = {"Id":"ExposeApiResponseDataToCalculations","Label":"[10.24]Expose API response data to calculations","Impact":"Shows the ApiResponseData calculation block in the form editor, allowing form calculations to read fields from a Wait for API activity's stored response payload.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
